<app-client-details-navigation *ngIf="currentItem" [clientID]="currentItem?.ID"></app-client-details-navigation>
<div class="main-page-content">
  <div class="main-page-content-block">


    <div class="main-page-content-block" *ngIf="currentItem!=null">

        <div class="row">
          <div class="col mb-3">
            <label for="selectPermission">Permission</label>
            <select class="form-control" name="selectPermission" [(ngModel)]="currentPermission" autocomplete="off" placeholder="Permission">
              <option *ngFor="let p of permissions" [ngValue]="p">
                {{p.Category}} - {{p.Permission}}:
                {{p.Description}}
              </option>
            </select>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-6 mb-3" *ngIf="userAndRoles && currentPermission">
            <label for="UserTypes">Users:</label>

            <p-listbox [(ngModel)]="currentPermission.UserIDs"
                       [options]="userAndRoles?.Users"
                       optionValue="ID"
                       optionLabel="UserName"
                       [filter]="true"
                       [multiple]="true"
                       [checkbox]="true"
                       styleClass="col "
                       listStyleClass=""
                       [showToggleAll]="false"
                       class="flat-listbox"
                       [virtualScroll]="true" [virtualScrollItemSize]="40">
              <ng-template pTemplate="item" let-user>
                <div class="flex items-center gap-2 ">
                  {{ user.FirstName }} {{user.LastName}} - {{user.Email}} ({{user.UserName}} {{user.Hidden ? 'Hidden' : ''}} {{user.Inactive ? 'Inactive' : ''}})
                </div>
              </ng-template>
            </p-listbox>

          </div>
          <div class="col-6 mb-3" *ngIf="userAndRoles && currentPermission">
            <label for="UserTypes">Roles:</label>

            <p-listbox [(ngModel)]="currentPermission.RoleIDs"
                       [options]="userAndRoles?.Roles"
                       optionValue="ID"
                       [filter]="true"
                       [multiple]="true"
                       [checkbox]="true"
                       styleClass="col "
                       listStyleClass=""
                       [showToggleAll]="false"
                       class="flat-listbox"
                       [virtualScroll]="true" [virtualScrollItemSize]="40">
              <ng-template pTemplate="item" let-role>
                <div class="flex items-center gap-2 ">
                  {{ role.UserType }} - {{role.Description}}
                </div>
              </ng-template>
            </p-listbox>

          </div>
        </div>
        <div class="row" *ngIf="userAndRoles && currentPermission">
          <div class="col text-center">
            <button class="btn btn-lg btn-primary" type="submit" id="btnSave" [class.button-loading]="loading" (click)="save()">Save</button>
          </div>
        </div>
      </div>
    </div>
</div>
